module.exports = __webpack_public_path__ + "img/instrument_panel_Injection_molding.b0f3c36a.jpg";